/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki
 */
export interface FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki {
    /**
     * 
     * @type {number}
     * @memberof FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki
     */
    AppId: number;
}

/**
 * Check if a given object implements the FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki interface.
 */
export function instanceOfFxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki(value: object): value is FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki {
    if (!('AppId' in value) || value['AppId'] === undefined) return false;
    return true;
}

export function FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassnikiFromJSON(json: any): FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki {
    return FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassnikiFromJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassnikiFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki {
    if (json == null) {
        return json;
    }
    return {
        
        'AppId': json['AppId'],
    };
}

export function FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassnikiToJSON(json: any): FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki {
    return FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassnikiToJSONTyped(json, false);
}

export function FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassnikiToJSONTyped(value?: FxGamesLibWebPlatformDataOptionsPlatformDataOptionsOdnoklassniki | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AppId': value['AppId'],
    };
}

